import React, { useEffect, useState } from "react";
import { EditPage } from "@equipedigitalfloripa/ed-cms/components";
import * as MenuApi from "../api/menu";
import { fetchItems as getLocations } from "../api/location";

const EditMenu = ({ edit }) => {
  const [locations, setLocations] = useState([]);
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    MenuApi.fetchItems().then((res) => {
      let menuOptions = [];
      res.data.forEach((menu) => {
        menuOptions.push({ value: menu._id, label: menu.name });
      });
      setMenu(menuOptions);
    });
  }, []);

  const selectedData = [
    {
      name: "_id",
      type: "hidden",
      title: "Id",
    },
    {
      name: "image",
      type: "dragdrop",
      title: "Imagem",
      options: {
        maxFiles: 1,
      },
      validation: {
        required: true,
      },
    },
    {
      name: "isSubmenu",
      type: "checkbox",
      title: "É um submenu?",
    },
    {
      name: "father",
      type: "select",
      title: "Menu pai",
      selectOptions: menu,
      conditional: [
        {
          name: "isSubmenu",
          equal: true,
        },
      ],
    },
    {
      name: "name",
      type: "text",
      title: "Nome do menu",
      validation: {
        required: true,
      },
      options: {
        maxLength: "150",
      },
    },
    {
      name: "helpline",
      type: "text",
      title: "Linha de apoio",
    },
    {
      name: "url",
      type: "text",
      title: "Link de redirecionamento",
    },
  ];
  return (
    <EditPage
      title={edit ? "Editar Menu" : "Adicionar Menu"}
      subtitle={
        edit
          ? "Alterando informações do Menu"
          : "Adicionando informações do Menu"
      }
      selectedData={selectedData}
      addFunction={MenuApi.addItem}
      fetchFunction={MenuApi.fetchItem}
      editFunction={MenuApi.editItem}
      uploadFunction={MenuApi.uploadMenu}
      edit={edit}
      url="menu"
    />
  );
};

export default EditMenu;
